export default "__VITE_ASSET__CRxmCpBm__"